import React from 'react';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from '../../styles/styles.js';

const Card = (props) => {
  const classes = useStyles();
  return (
    <div
      className={classNames(classes.root, props.className)}
      data-testid={props['data-testid']}>
      {props.children}
    </div>
  );
};

Card.propTypes = {
  children: PropTypes.any,
};

const useStyles = styles.makeStyles(
  (theme) => {
    const hasNoOverride = isEmpty(theme.overrides) ||
                          isEmpty(theme.overrides.MuiCard) ||
                          isEmpty(theme.overrides.MuiCard.root);
    const cardTheme = hasNoOverride ? {} : theme.overrides.MuiCard.root;
    return {
      root: {
        ...cardTheme,
        backgroundColor: 'white',
        borderColor: 'transparent',
        textAlign: 'left',
        borderRadius: theme.dimens.radius,
        width: '100%',
        position: 'relative',
        boxShadow: 'rgba(0,0,0,.07) 0px 0px 12px',
      }
    }
  }
);

export default Card;
